// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 27) return "static/js/5c7e7a302a9f9a8b348c.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"4865f063fb505647e621","148":"94193e50da2c4ff79cf9","149":"af9035f8356d809db50f"}[chunkId] + ".chunk.js";
};